import * as React from 'react';

import { ListItem, Box, Collapse } from '@mui/material';
import { useRouter } from 'next/router';

import { useDevice } from '@hooks';
import theme from 'config/theme';

import { MenuItemLink } from '../MenuItemLink';
import styles from './submenu.style';

export const Submenu = ({ isExpanded, route, onCloseMenu }) => {
  const { pathname } = useRouter();
  const { isMobile, isTablet } = useDevice();

  const handleClick = () => {
    if (isMobile || isTablet) onCloseMenu();
  };

  return (
    <Collapse
      in={isExpanded}
      timeout="auto"
      unmountOnExit
      aria-expanded={isExpanded}
    >
      <Box sx={styles.submenu} role="menu" aria-label={`${route.key}-submenu`}>
        {route.options?.map((item, idx) => {
          if (item.hide) return null;

          const isSelectedSubItem =
            !!item.url && pathname.indexOf(item.url) > -1 && item.url !== '/';

          const isFirst = idx === 0;

          const isLast = idx === route.options.length - 1;

          return (
            <ListItem
              key={item.key}
              component={item.url ? MenuItemLink : Box}
              href={item.url || undefined}
              onClick={handleClick}
              sx={{
                ...styles.subMenuItem(isFirst, isLast),
                color: isSelectedSubItem
                  ? 'black'
                  : theme.customValues.sidebar.textColor,
                backgroundColor: isSelectedSubItem
                  ? theme.customValues.sidebar.bgHover
                  : 'inherit',
                pointerEvents: !item.url || item.disabled ? 'none' : 'auto',
                opacity: !item.url || item.disabled ? 0.38 : 1,
              }}
              role="menuitem"
              aria-disabled={!item.url || !!item.disabled}
            >
              <Box
                sx={{
                  width: '22px',
                }}
              />
              <Box sx={{ paddingLeft: '20px' }}>{item.title}</Box>
            </ListItem>
          );
        })}
      </Box>
    </Collapse>
  );
};

export default Submenu;
